import React, {useState, useEffect} from "react";
import CustomDialog from "../../../core/components/ui/CustomDialog";
import {useTheme, Box, CircularProgress} from "@mui/material";
import useGatePass from "../hooks/useGatePass";
import CustomDialogLoaderComponent from "../../../core/components/common/custom-dialog-loader.component";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import {QRCodeSVG} from "qrcode.react";

const GenerateSingleGatePassDialog = (props) => {
    const {open, setOpen, organizationId} = props;

    const theme = useTheme();
    
    const {isGeneratingSingleGatePass, generatedGatePassData, generateSingleGatePass} = useGatePass();

    const [firstNameInput, setFirstNameInput] = useState(null);
    const [middleNameInput, setMiddleNameInput] = useState(null); 
    const [lastNameInput, setLastNameInput] = useState(null);
    const [plateNoInput, setPlateNoInput] = useState(null);
    const [contactNoInput, setContactNoInput] = useState(null);
    const [idNoInput, setIdNoInput] = useState(null);
    const [generatedGatePassQRCode, setGeneratedGatePassQRCode] = useState(null);


    useEffect(() => {
        if (generatedGatePassData) {   
            setGeneratedGatePassQRCode(generatedGatePassData?.online_qr);
        }
    }, [generatedGatePassData])

    console.log('organization UID', organizationId)


    const handleTextfieldChange = (e, type) => {
        const {value} = e.target;

        switch (type) {
            case "firstName":
                setFirstNameInput(value);
                break;

            case "middleName": 
                setMiddleNameInput(value);   
                break;
                
            case "lastName":
                setLastNameInput(value);   
                break;   

            case "plateNo":
                setPlateNoInput(value);
                break;
            
            case "contactNo":
                setContactNoInput(value);
                break;
            
            case "idNo":
                setIdNoInput(value);
                break;

            default:
                break;
        }
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleGenerateSingleGatePass = () => {
        const payload = {
            first_name: firstNameInput,
            middle_name: middleNameInput,   
            last_name: lastNameInput,
            plate_number: plateNoInput,
            contact_number: contactNoInput,
            id_no: idNoInput,
            orgUID: organizationId
        };

        generateSingleGatePass(payload, setOpen);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Generate",
            onClick: (e) => (firstNameInput && middleNameInput && lastNameInput && plateNoInput && contactNoInput && idNoInput) ? handleGenerateSingleGatePass(e) : null,
            customStyles: {
                opacity: (firstNameInput && middleNameInput && lastNameInput && plateNoInput && contactNoInput && idNoInput && !isGeneratingSingleGatePass) ? "100%" : "55%",
                cursor: (firstNameInput && middleNameInput && lastNameInput && plateNoInput && contactNoInput && idNoInput && !isGeneratingSingleGatePass) ? "pointer" : "not-allowed !important",
                visibility: (isGeneratingSingleGatePass) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isGeneratingSingleGatePass) ? null : handleClose}
                title="Generate Gate Pass"
                hasDividers={true}
                content={
                    <Box>
                        {(isGeneratingSingleGatePass) ? 
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: theme.palette.primary.main}} />} 
                                    message={"Generating gate pass..."}
                                />
                            </Box>
                        // : 
                        //     (generatedGatePassData && !isGeneratingSingleGatePass) ?
                        //         <Box sx={{textAlign: "center", p: "18px 36px 42px"}}>
                        //             <QRCodeSVG value={generatedGatePassQRCode} style={{width: 231, height: 231}} />

                        //             <CustomTypography
                        //                 variant="body1"
                        //                 text={"Scan QR Code to view gate pass"}
                        //                 customStyles={{
                        //                     marginBottom: 0, 
                        //                     mt: 1
                        //                 }}
                        //             />
                        //         </Box>
                                    
                        :
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"First Name"}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter first name"}
                                    variant={"outlined"}
                                    value={firstNameInput}
                                    onChange={(e) => handleTextfieldChange(e, "firstName")}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                /> <br/> <br/>

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Middle Name"}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter middle name"}
                                    variant={"outlined"}
                                    value={middleNameInput}
                                    onChange={(e) => handleTextfieldChange(e, "middleName")}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                /> <br/> <br/>
                            
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Last Name"}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter last name"}
                                    variant={"outlined"}
                                    value={lastNameInput}
                                    onChange={(e) => handleTextfieldChange(e, "lastName")}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                /> <br/> <br/>
                            
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Plate No."}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter plate no."}
                                    variant={"outlined"}
                                    value={plateNoInput}
                                    onChange={(e) => handleTextfieldChange(e, "plateNo")}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                /> <br/> <br/>

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Contact No."}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter contact no."}
                                    variant={"outlined"}
                                    value={contactNoInput}
                                    onChange={(e) => {
                                        const numbersOnly = e.target.value.replace(/\D/g, '');
                                        handleTextfieldChange({target: {value: numbersOnly}}, "contactNo");
                                    }}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                    inputProps={{
                                        inputMode: "numeric",  
                                        maxLength: 11     
                                    }}
                                /> <br/> <br/>

                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"ID No."}
                                    customStyles={{
                                        marginBottom: 0, 
                                    }}
                                />

                                <CustomTextField 
                                    placeholder={"Enter ID no."}
                                    variant={"outlined"}
                                    value={idNoInput}
                                    onChange={(e) => handleTextfieldChange(e, "idNo")}
                                    fullWidth={true}
                                    multiline={false}
                                    hiddenLabel
                                /> <br/> <br/>
                            </>
                        } 
                    </Box>
                }
                actions={!isGeneratingSingleGatePass && !generatedGatePassQRCode && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default GenerateSingleGatePassDialog
